var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0625 4.59146C10.0625 7.12083 8.53458 9.29158 6.5 9.29158C4.46383 9.29158 2.9375 7.12083 2.9375 4.59067C2.9375 2.06209 4.25167 0.583252 6.5 0.583252C8.74833 0.583252 10.0625 2.06129 10.0625 4.59146ZM0.247418 14.9457C0.552209 15.3083 1.86479 16.4166 6.5 16.4166C11.1352 16.4166 12.447 15.3083 12.7526 14.9465C12.7809 14.9117 12.8019 14.8715 12.8141 14.8283C12.8264 14.7852 12.8297 14.74 12.8238 14.6955C12.7542 13.9973 12.1256 10.8749 6.5 10.8749C0.874418 10.8749 0.245834 13.9973 0.175376 14.6955C0.169643 14.74 0.173076 14.7853 0.185464 14.8284C0.197853 14.8716 0.218936 14.911 0.247418 14.9457Z",
    fill: "#52447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorProfile);
export default __webpack_public_path__ + "static/media/VectorProfile.2ae74725aaf68f438bc13aa2aea5da32.svg";
export { ForwardRef as ReactComponent };